export default {
	data() {
		return {
			idInputDisable: false,
			nameInputDisable: false,
			sliderShows: [],
			// 控制对话显示
			dialogTableVisible: false,
			formLabelWidth: "120px",
			dialogTableVisible2: false,

			formLabelWidth: "120px",
			// 要更改的图片的必须信息
			updateImg: {
				id: '',
				name: '',
				sort: '',
				url: '',
				file_name: ''
			},
			//上传图片后返回的唯一文件名字
			fileName: '',
			// 上传图片的接口地址
			addresss: this.baseUrl + 'file/upload_banner?token=' + this.$store.state.authority_management,
			// 是否显示上传的图片
			dialogVisible: false,
			//自己填写的图片名称
			imageName: '',
			//轮播图的链接
			imgHref: '',
			//轮播图的排序
			imgSort: '',
			//填写修改图片名称
			updateImageName: '',
			//修改图片名称的弹出框
			dialogUpdateImgVisible: false,

			// 轮播图图片服务器地址
			imgBannerUrl: this.bannerUrl,
			// 图片名称
			imgName: '',
			//轮播图请求头
			// 不需要置顶的轮播图id数组
			notTopIdList: [],
			// 轮播图的sort数组
			sortList: [],
			// 轮播图数组中最大的sort值，在新增轮播图的时候作为参数传入
			maxNum: null
		}
	},
	methods: {
		httpreq(q) {
			let Fromdata = new FormData()
			Fromdata.append('file', q.file)
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}
			this.$http.post(this.addresss, Fromdata, config).then(res => {
				// // console.log('res',res)
				this.fileName = res.data.result
				this.imgName = ''
				this.updateImg.file_name = res.data.result
			})
		},
		confirmUpdateImg() {
			if (this.updateImg.name == '') {
				this.$message({
					showClose: true,
					type: 'error',
					message: '图片名不能为空'
				});
				return false;
			} else if (this.updateImg.sort == '') {
				this.$message({
					showClose: true,
					type: 'error',
					message: '请输入轮播图排序'
				});
			} else {
				let data = {
					name: this.updateImg.name,
					sort: this.updateImg.sort,
					url: this.updateImg.url,
					id: this.updateImg.id,
					file_name: this.updateImg.file_name,
					token: this.$store.state.authority_management
				}
				// // console.log('修改轮播图的数据为')
				// // console.log(data);
				this.$post('banner/update', data).then(res => {
					if (res.data.status == 'success') {
						this.$message({
							showClose: true,
							type: 'success',
							message: '更新成功'
						});
						// // console.log('修改后的轮播图数据为')
						// // console.log(res)
						// 清空已上传的文件列表
						this.$refs['upload'].clearFiles()
						//更新后重新请求数据刷新
						this.getData();
						this.dialogUpdateImgVisible = false
					} else {
						this.$message({
							showClose: true,
							type: 'error',
							message: '更新失败'
						});
					}
				})
			}


		},

		// 取消更新轮播图 
		closeUpdate() {
			this.dialogUpdateImgVisible = false
			this.$refs['upload'].clearFiles()
		},

		// 修改图片资源名字
		handleUpdate(obj) {
			// // console.log(obj)
			// // console.log(obj);
			this.dialogUpdateImgVisible = true;
			this.updateImg.id = obj.id;
			this.updateImg.name = obj.name;
			this.updateImg.url = obj.url;
			this.updateImg.sort = obj.sort;
			this.imgName = obj.file_name
		},
		onReset(formName) {
			// 这里是清空修改中的内容 不用管
			this.dialogTableVisible = false;
			this.$refs[formName].resetFields();
		},
		hendelDelete(id) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.confirmDelete(id);
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});

		},
		confirmDelete(id) {
			let data = {
				token: this.$store.state.authority_management,
				id: id
			}
			this.$post('banner/delete', data).then(res => {
				if (res.data.status == 'success') {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					//删除成功后请求刷新数据
					this.getData();
				} else {
					this.$message({
						type: 'success',
						message: '删除失败'
					});
				}
			})
		},
		//上传图片超过一张时候触发
		exceed() {
			// alert('只能上传一张图片')
			this.$message({
				message: '只能上传一张图片',
				type: 'error'
			})
		},
		handlePictureCardPreview(file) {
			// // console.log(file)
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},

		//图片成功上传到服务器
		handleSuccess(response, file) {
			// 上传成发生的事件
			// // console.log('上传成功')
			// // console.log(response);
			// // console.log(file);

			// // console.log(fileList);
			// this.uploadImgList=file.name;
			// // console.log('错过了')
			// // console.log(response.result)
			this.fileName = response.result

			// if (response.status == 'success') {
			// alert('上传图片成功了');
			// this.dialogTableVisible = false;
			// }
		},

		// 编辑弹窗上传图片成功后调用的方法
		handleUploadSuccess(response, file) {
			// 修改弹窗的图片修改成功后, 将原来的图片隐藏, 显示上传成功后的图片
			this.imgName = ''

			this.updateImg.file_name = response.result
		},

		//确定增加轮播图图片
		confirmSliderShow() {
			//三个条件的表单校验，图片名字不能空，图片要上传，排序要写好
			if (this.imageName == '') {
				this.$message({
					showClose: true,
					type: 'error',
					message: '图片名不能为空'
				});
				return false;
			} else if (this.fileName == '') {
				this.$message({
					showClose: true,
					type: 'error',
					message: '请确保已经上传图片'
				});
			// } else if (this.imgSort == '') {
			// 	this.$message({
			// 		showClose: true,
			// 		type: 'error',
			// 		message: '请输入轮播图排序'
			// 	});
			} else {
				let data = {
					name: this.imageName,
					file_name: this.fileName,
					shop_id: this.$store.state.store.id,
					sort: this.maxNum + 1,
					url: this.imgHref,
					token: this.$store.state.authority_management
				}
				//发起请求添加轮播图
				this.$post('banner/create', data).then(res => {
					if (res.data.status == 'success') {
						this.$message({
							showClose: true,
							type: 'success',
							message: '轮播图添加成功！'
						});
						//关闭弹窗
						this.dialogTableVisible = false;
						//清空表单
						this.imageName = '',
							this.fileName = '',
							this.imgSort = '';
						this.imgHref = '';
						//重新请求数据刷新
						this.getData();
					} else {
						this.$message({
							showClose: true,
							type: 'error',
							message: '轮播图添加失败！'
						});
					}
				})
			}

		},
		//上传图片的触发
		beforeUpload(file) {
			//校验图片格式
			const isImage = file.name.replace(/.+\./, "");
			if (['jpg', 'jpeg', 'png', 'JPG', 'JPEG'].indexOf(isImage) == '-1') {
				// // console.log('进入判断')
				this.$message({
					showClose: true,
					message: '上传文件类型错误！',
					type: 'warning'
				})
				return false
			}
		},
		//更改上传的图片
		handleChange(file, fileList) {
			this.fileList = fileList;
		},
		//获取轮播图的数据
		getData() {
			// console.log('调用我了')
			// 获取数据
			let data = {
				token: this.$store.state.authority_management,
				offset: 0,
                length: 999,
                shop_id: this.$store.state.store.id
			};
			//发起请求获取所有轮播图
			this.$post('banner/shop_search', data).then(res => {
				let list = res.data.result.data;
				list.sort(this.compare('sort'))
				this.sliderShows = list
				// // console.log(list)

				// 获取轮播图的sort
				this.getSortList(this.sliderShows)
			})
		},
		// clearFil() {
		//     this.$refs['my-upload'].clearFiles();
		// }

		// 比较属性值的方法
		compare(property) {
			return (a, b) => {
				let value1 = a[property]
				let value2 = b[property]
				return value1 - value2
			}
		},

		// 置顶图片
		stick(data) {
			// 置顶所选的轮播图
			this.$post('banner/update', {
				token: this.$store.state.authority_management,
				id: data.id,
				sort: 1
			})

			// 获取不需要置顶的轮播图
			this.$post('banner/search_not_id', {
				token: this.$store.state.authority_management,
				shop_id: this.$store.state.store.id,
				offset: 0,
				length: 999,
				id_arr: JSON.stringify([data.id])
			}).then(res => {
				if (res.status === 200) {
					this.notTopIdList = res.data.result.data
					// // console.log(this.notTopIdList)
					// 将不需要置顶的轮播图的sort+1
					for (let i = 0; i < this.notTopIdList.length; i++) {
						this.$post('banner/update', {
							token: this.$store.state.authority_management,
							id: this.notTopIdList[i].id,
							sort: this.notTopIdList[i].sort * 1 + 1
						}).then(res => {
							if (i === this.notTopIdList.length - 1) {
								this.getData()
							}
						})
					}
				}
			})
		},

		// 上移图片
		moveUp(data) {
			let sort1 = data.sort
			let comeBack = ''
			let list = this.sliderShows
			for (let i = 0; i < list.length; i++) {
				if (list[i].sort * 1 == sort1) {
					comeBack = list[i - 1].sort
					this.$post('banner/update', {
						token: this.$store.state.authority_management,
						id: list[i - 1].id,
						sort: sort1
					}).then(res => {

					})
					this.$post('banner/update', {
						token: this.$store.state.authority_management,
						id: data.id,
						sort: comeBack
					}).then(res => {
						this.getData()
					})
					return false
				}
			}
		},

		// 下移图片
		moveDown(data) {
			let sort1 = data.sort
			let comeBack = ''
			let list = this.sliderShows
			for (let i = 0; i < list.length; i++) {
				if (list[i].sort * 1 > sort1) {
					comeBack = list[i].sort
					this.$post('banner/update', {
						token: this.$store.state.authority_management,
						id: list[i].id,
						sort: sort1
					}).then(res => {

					})
					this.$post('banner/update', {
						token: this.$store.state.authority_management,
						id: data.id,
						sort: comeBack
					}).then(res => {
						this.getData()
					})
					return false
				}
			}
		},

		// 获取轮播图序号数组
		getSortList(list) {
			// console.log(list)
			let arr = []
			for (let i = 0; i < list.length; i++) {
				arr.push(list[i].sort * 1)
			}
			this.sortList = arr
			// console.log(this.sortList)
			this.getMaxNum(this.getMaxNum(this.sortList))
		},

		// 获取数组中的最大值
		getMaxNum(arr) {
			if (!this.$isAbnormal(arr)) {
				let num = 0
				for (let i in arr) {
					if (num < arr[i]) {
						num = arr[i]
					}
				}
				this.maxNum = num
				// console.log(this.maxNum)
			}
		}

	},
	created() {
		this.getData();
	}
}
